import React, { useEffect, useRef, useState } from 'react';
import { Card, CardBody, CardTitle, Col, Container, Input, Nav, NavItem, Row } from 'reactstrap';
import { Mic, Send } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import Footer from 'components/VerticalLayout/Footer';

const Question = () => {
    const [message, setMessage] = useState('');
    const [activeTab, setActiveTab] = useState('1');
    const scrollRef = useRef(null);
    const suggestedQuestions = [
        "What is the price of the property?",
        "Can I schedule a visit?",
        "Is financing available?",
        "What are the nearby amenities?",
        "3 BHK flats for rent in Gotri Vadodara?",
        "Rent of 3 BHK apartment in Gotri?",
        "3 BHK apartment rent price Gotri?",
        "How much does a 3 BHK apartment cost to rent in Gotri?",
        "3 BHK flats for rent near Gotri Vadodara?",
        "3 BHK apartment for rent in Gotri with amenities?",
        "3 BHK apartment for rent in Gotri with parking?",
        "3 BHK apartment for rent in Gotri furnished?",
        "What is the price of the property?",
        "Can I schedule a visit?",
        "Is financing available?",
        "What are the nearby amenities?",
        "3 BHK flats for rent in Gotri Vadodara?",
        "Rent of 3 BHK apartment in Gotri?",
        "3 BHK apartment rent price Gotri?",
        "How much does a 3 BHK apartment cost to rent in Gotri?",
        "3 BHK flats for rent near Gotri Vadodara?",
        "3 BHK apartment for rent in Gotri with amenities?",
        "3 BHK apartment for rent in Gotri with parking?",
        "3 BHK apartment for rent in Gotri furnished?",
        "What is the price of the property?",
        "Can I schedule a visit?",
        "Is financing available?",
        "What are the nearby amenities?",
        "3 BHK flats for rent in Gotri Vadodara?",
        "Rent of 3 BHK apartment in Gotri?",
        "3 BHK apartment rent price Gotri?",
        "How much does a 3 BHK apartment cost to rent in Gotri?",
        "3 BHK flats for rent near Gotri Vadodara?",
        "3 BHK apartment for rent in Gotri with amenities?",
        "3 BHK apartment for rent in Gotri with parking?",
        "3 BHK apartment for rent in Gotri furnished?",
    ];

    const handleSendMessage = (msg) => {
        const text = msg || message;
        if (text.trim()) {
            const whatsappURL = `https://wa.me/919586363303?text=${encodeURIComponent(text)}`;
            window.open(whatsappURL, '_blank');
        }
    };
    useEffect(() => {
        const interval = setInterval(() => {
            if (scrollRef.current) {
                scrollRef.current.scrollTop += 1;
                if (scrollRef.current.scrollTop >= scrollRef.current.scrollHeight - scrollRef.current.clientHeight) {
                    scrollRef.current.scrollTop = 0;
                }
            }
        }, 100);
        return () => clearInterval(interval);
    }, []);
    const handleSendTextareaMessage = () => {
        if (!message.trim()) {
            console.log("Empty message, not sending.");
            return;
        }

        const whatsappURL = `https://wa.me/919586363303?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');

        setMessage(""); // Clear textarea after sending
    };

    const [listening, setListening] = useState(false);
    const recognitionRef = useRef(null);

    // Voice recognition setup
    useEffect(() => {
        if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
            const recognition = new SpeechRecognition();
            recognition.continuous = false;
            recognition.lang = 'en-IN';
            recognition.interimResults = false;

            recognition.onstart = () => setListening(true);
            recognition.onend = () => setListening(false);
            recognition.onerror = (event) => console.error("Speech recognition error:", event);

            recognition.onresult = (event) => {
                const transcript = event.results[0][0].transcript;
                setMessage(prev => prev + " " + transcript);
            };

            recognitionRef.current = recognition;
        } else {
            alert("Sorry, your browser doesn't support speech recognition.");
        }
    }, []);

    const handleMicClick = () => {
        if (recognitionRef.current) {
            if (listening) {
                recognitionRef.current.stop();
            } else {
                recognitionRef.current.start();
            }
        }
    };

    return (
        <React.Fragment>
            <div className="page-content" style={{ color: "#fff", fontFamily: "'Roboto', sans-serif" }}>
                <Container fluid={true} className="py-1">
                    <Row className="justify-content-center">
                        <Col xl={8} lg={8} md={10}>
                            <Card style={{ background: "rgba(255, 255, 255, 0.1)", border: "none", borderRadius: "15px", padding: "20px" }}>
                                <CardBody className="d-flex flex-column align-items-center">
                                    <CardTitle className="mb-4 text-center" style={{ fontSize: "1.8rem", fontWeight: "600" }}>
                                        I Want
                                    </CardTitle>
                                    <div style={{ position: "relative", width: "100%" }}>
                                        <Input
                                            type="textarea"
                                            className="form-control"
                                            id="question"
                                            name="question"
                                            placeholder="Type your question here..."
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                            style={{
                                                backgroundColor: "rgba(255, 255, 255, 0.2)",
                                                color: "#fff",
                                                padding: "15px",
                                                borderRadius: "10px",
                                                minHeight: "120px",
                                                resize: "none",
                                                transition: "all 0.3s ease",
                                                '::placeholder': { color: '#fff' }
                                            }}
                                            onFocus={(e) => e.target.style.backgroundColor = "rgba(255, 255, 255, 0.4)"}
                                            onBlur={(e) => e.target.style.backgroundColor = "rgba(255, 255, 255, 0.2)"}
                                        />
                                        {/* Mic Button */}
                                        <button
                                            type="button"
                                            onClick={handleMicClick}
                                            style={{
                                                position: "absolute",
                                                bottom: "75px",
                                                right: "10px",
                                                background: listening ? "red" : "linear-gradient(to right, #6a11cb, #2575fc)",
                                                border: "none",
                                                padding: "8px 10px",
                                                borderRadius: "50%",
                                                color: "#fff",
                                                cursor: "pointer",
                                                boxShadow: "0 0 10px rgba(0,0,0,0.5)"
                                            }}
                                            title={listening ? "Listening..." : "Start voice input"}
                                        >
                                            <Mic size={18} />
                                        </button>
                                        <button
                                            type="button"
                                            onClick={handleSendTextareaMessage}
                                            style={{
                                                position: "absolute",
                                                bottom: "10px",
                                                right: "10px",
                                                background: "linear-gradient(to right, #6a11cb, #2575fc)",
                                                border: "none",
                                                padding: "8px 12px",
                                                borderRadius: "20px",
                                                color: "#fff",
                                                cursor: "pointer"
                                            }}
                                        >
                                            <Send size={18} />
                                        </button>
                                    </div>
                                    <div className="mt-4" style={{ overflow: "hidden", width: "100%" }}>
                                        <div ref={scrollRef} style={{ overflowY: "auto", maxHeight: "430px", scrollbarWidth: "thin" }}>
                                            <Nav className="d-grid" style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gridTemplateRows: "repeat(4, auto)", gap: "10px" }}>
                                                {suggestedQuestions.map((q, index) => (
                                                    <NavItem key={index}>
                                                        <NavLink
                                                            onClick={() => handleSendMessage(q)}
                                                            style={{
                                                                cursor: "pointer",
                                                                color: "#fff",
                                                                background: "rgba(255, 255, 255, 0.2)",
                                                                padding: "10px 15px",
                                                                borderRadius: "5px",
                                                                textDecoration: "none",
                                                                display: "block",
                                                                textAlign: "center",
                                                                transition: "background 0.3s ease"
                                                            }}
                                                            onMouseEnter={(e) => e.target.style.background = "rgba(255, 255, 255, 0.4)"}
                                                            onMouseLeave={(e) => e.target.style.background = "rgba(255, 255, 255, 0.2)"}
                                                        >
                                                            {q}
                                                        </NavLink>
                                                    </NavItem>
                                                ))}
                                            </Nav>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

            </div>
            {/* Footer */}
            <Footer />

        </React.Fragment>
    );
};

export default Question;